import React from 'react';
import { Button } from '@askporter/component-library/Button';
import { FormControlLabel } from '@askporter/component-library/FormControlLabel';
import { Switch } from '@askporter/component-library/Switch';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
interface CustomiseViewProps {
  t: (key: string) => string;
  cookies: {
    rum: boolean;
  };
  toggleCookiePreference: (cookie: string) => void;
  setDialogView: (view: 'INITIAL' | 'CUSTOMISE') => void;
  handleSaveOnClick: () => void;
}
const CustomiseView: React.FC<CustomiseViewProps> = ({
  t,
  cookies,
  toggleCookiePreference,
  setDialogView,
  handleSaveOnClick,
}) => {
  return (
    <>
      <DialogTitle variant="h3">{t('cookie_banner:customise:title')}</DialogTitle>
      <DialogContent>
        <FormControlLabel
          value="rum"
          control={<Switch size="small" checked={cookies.rum} onChange={() => toggleCookiePreference('rum')} />}
          label={t('cookie_banner:customise:rum_switch_label')}
          labelPlacement="start"
          sx={{ justifyContent: 'space-between', width: '100%', m: 0 }}
        />
      </DialogContent>
      <DialogActions sx={{ alignItems: 'space-between' }} disableSpacing>
        <Button onClick={() => setDialogView('INITIAL')}>{t('cookie_banner:customise:back_button')}</Button>
        <Button variant="contained" sx={{ ml: 6 }} onClick={handleSaveOnClick}>
          {t('cookie_banner:customise:save_button')}
        </Button>
      </DialogActions>
    </>
  );
};
export default CustomiseView;
